function getScheduler(steps) {
  const stepsFns = {};
  const api = {};
  let isScheduled = false;
  const resolvedPromise = Promise.resolve();
  function run(tasks) {
    let task;
    while (task = tasks.shift()) {
      task();
    }
  }
  function flush() {
    steps.forEach(function runStep(step) {
      run(stepsFns[step]);
    });
    isScheduled = false;
    if (steps.reduce((length, step) => length + stepsFns[step].length, 0) > 0) {
      scheduleFlush();
    }
  }
  function scheduleFlush() {
    if (isScheduled) {
      return;
    }
    isScheduled = true;
    resolvedPromise.then(flush);
  }
  steps.forEach((step) => {
    stepsFns[step] = [];
    api[step] = function add(fn) {
      stepsFns[step].push(fn);
      scheduleFlush();
    };
  });
  return api;
}
const instances = /* @__PURE__ */ new Map();
const domSchedulerSteps = ["read", "write", "afterWrite"];
function useScheduler(steps = domSchedulerSteps) {
  const key = steps.join("-");
  if (instances.has(key)) {
    return instances.get(key);
  }
  const scheduler = getScheduler(steps);
  instances.set(key, scheduler);
  return scheduler;
}
const domScheduler = useScheduler(domSchedulerSteps);
export {
  domScheduler,
  useScheduler
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
